import PreviewCard from './preview-card';
import {compose} from 'redux';
import InviteLogin from './invite-login';
import InviteUrl from './invite-url';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {LoggedIn} from '../../../components/auth';
import Modal from '@homeaway/react-modal';
import React from 'react';
import RolePermissions from '../../../components/permissions';
import ShareUrl from './share-url';
import {withCollaborateState} from './state';
import {withTranslationsAsProps} from '../../../components/translations';
import './collaborate.less';

export function Divider({text}) {
    return (
        <div className="collab-modal__divider">
            <hr className="collab-modal__divider-hr" />
            <span className="collab-modal__divider-text">{text}</span>
        </div>
    );
}

export function CollaborateModal({
    boardId,
    collaborate,
    endDate,
    error,
    fullLocale,
    invite,
    inviteUrl,
    isMobile,
    isOpen,
    langOr,
    listings,
    loading,
    login,
    loginUrl,
    name,
    role,
    siteName,
    startDate,
    title
}) {
    return (
        <Modal
            className="collab-modal"
            id="collaborate-modal"
            isOpen={isOpen}
            onClose={collaborate}
            title={title}
        >
            <PreviewCard
                listings={listings}
                name={name}
            />
            <LoadingOverlay loading={loading} />
            <LoggedIn>
                <RolePermissions role={role} owner>
                    <div className="margin-bottom-5x">
                        <InviteUrl
                            boardId={boardId}
                            error={error}
                            endDate={endDate}
                            fetch={invite}
                            isMobile={isMobile}
                            startDate={startDate}
                            url={inviteUrl}
                        />
                        <Divider text={langOr} />
                    </div>
                </RolePermissions>
            </LoggedIn>
            <div className="margin-bottom-5x">
                <ShareUrl
                    boardId={boardId}
                    endDate={endDate}
                    isMobile={isMobile}
                    startDate={startDate}
                />
            </div>
            <LoggedIn inverse>
                <RolePermissions role={role} owner>
                    <Divider text={langOr} />
                    <div className="margin-bottom-5x">
                        <InviteLogin
                            boardId={boardId}
                            endDate={endDate}
                            error={error}
                            fetch={login}
                            fullLocale={fullLocale}
                            loginUrl={loginUrl}
                            siteName={siteName}
                            startDate={startDate}
                        />
                    </div>
                </RolePermissions>
            </LoggedIn>
        </Modal>
    );
}

export default compose(
    withCollaborateState,
    withTranslationsAsProps({
        'tripboards.or': 'langOr',
        'tripboards.share': 'title'
    })
)(CollaborateModal);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/invite-share-modal.js